import React, {useContext} from 'react';
import {LikeButton} from '../../LikeButton';
import {Breakpoints, styled} from '@volkswagen-onehub/components-core';
import {
  ResultsView,
  ResultsViewContext,
} from '../../../utils/results-view-context';
import {getLang} from '../../../translations';
import { useParams } from 'react-router-dom';
import { VehicleData } from '../../../types';
import { VehicleContext } from '../../../utils/vehicle-context';

interface CardLikeContainerInterface {
  view: ResultsView;
}

const CardLikeContainer = styled.div<CardLikeContainerInterface>`
  grid-area: like;
  justify-self: end;

  @media (min-width: ${Breakpoints.b960}px) {
    height: ${(props) => (props.view === ResultsView.LIST ? '100%' : 'unset')};
  }
`;

const CardLike: React.FC = () => {
  const view = useContext(ResultsViewContext).value;
  const lang = getLang();
  const params = useParams();

  const vehicle = useContext(VehicleContext) as VehicleData;
  const sold = vehicle.deleted;

  return (
    vehicle.vin || vehicle.stock_number
    ? <CardLikeContainer view={view}>
      <LikeButton
        vin={vehicle.vin || vehicle.stock_number}
        ariaModel={
          lang == 'fr'
            ? vehicle.model_name +
              ' ' +
              vehicle.trim['fr'] +
              ' ' +
              vehicle.year
            : vehicle.year +
              ' ' +
              vehicle.model_name +
              ' ' +
              vehicle.trim['en']
        }
        sold={sold}
        ulid={params.ulid}
      />
    </CardLikeContainer>
    : null
  );
};

export default CardLike;
